export default function initHeroStack() {
  const heroStack = document.querySelector('[data-hero-stack]');
  if (!heroStack) return;

  const images   = Array.from(heroStack.querySelectorAll('[data-hero-stack-image]'));
  const cards    = Array.from(heroStack.querySelectorAll('[data-hero-stack-cards]'));
  const prevBtn  = heroStack.querySelector('[data-hero-stack-prev]');
  const nextBtn  = heroStack.querySelector('[data-hero-stack-next]');
  const interval = parseInt(heroStack.getAttribute('data-hero-interval'), 10) || 6500;

  let index = 0;
  let timer = null;

  const setActive = (nextIndex) => {
    if (!images.length) return;
    index = (nextIndex + images.length) % images.length;
    images.forEach((img, i) => img.classList.toggle('is-active', i === index));
    cards.forEach((card, i) => card.classList.toggle('is-active', i === index));
  };

  const stop = () => { if (timer) { window.clearInterval(timer); timer = null; } };
  const start = () => {
    if (images.length <= 1) return;
    stop();
    timer = window.setInterval(() => setActive(index + 1), interval);
  };

  if (prevBtn) prevBtn.addEventListener('click', () => { setActive(index - 1); start(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { setActive(index + 1); start(); });

  heroStack.addEventListener('mouseenter', stop);
  heroStack.addEventListener('mouseleave', start);

  setActive(0);
  start();
}
